import * as api from "./api";

type feedbackRequest = {
	message: string;
	deviceId: string | null;
	username: string | null;
	className: string;
	stableId: string;
	uuid: string;
};

export const submitFeedback = async (
	message: string,
	classroomName: string,
	classroomStableId: string,
	classromId: string,
	options: object
): Promise<unknown> => {
	try {
		const request: feedbackRequest = {
			message,
			deviceId: localStorage.getItem("DEVICE"),
			username: localStorage.getItem("USERNAME"),
			className: classroomName,
			stableId: classroomStableId,
			uuid: classromId,
		};
		return (await api.post("/backend/feedback", request, options)) as unknown;
	} catch (err) {
		throw err;
	}
};
